export default __webpack_public_path__ + "static/tur-551986b5e2d22f8769796b71b3d4c895.png";